<template>
  <section>
    <h2>Message 信息提示</h2>
    <p class="desc">信息反馈组件</p>
    <h2>基础用法</h2>
    <div class="container">
      <div class="example">
        <span class="button-wrapper">
          <y-button type="primary" @click="handleInfoClick">提示</y-button>
        </span>
        <span class="button-wrapper">
          <y-button type="warning" @click="handleWarningClick">警告</y-button>
        </span>
        <span class="button-wrapper">
          <y-button type="success" @click="handleSuccessClick">成功</y-button>
        </span>
        <span class="button-wrapper">
          <y-button type="error" @click="handleErrorClick">错误</y-button>
        </span>
      </div>
      <div class="code-wrapper" v-highlight>
        <pre class="code"><code class="html" v-text="text1"></code></pre>
      </div>
    </div>
    <h2>会自动关闭的提示</h2>
    <div class="container">
      <div class="example">
        <span class="button-wrapper">
          <y-button type="primary" @click="handleInfoClick2">提示</y-button>
        </span>
      </div>
      <div class="code-wrapper" v-highlight>
        <pre class="code"><code class="html" v-text="text2"></code></pre>
      </div>
    </div>
    <h2>Attributes</h2>
    <div class="attr">
      <table>
        <thead>
          <tr>
            <th>参数</th>
            <th>说明</th>
            <th>类型</th>
            <th>可选值</th>
            <th>默认值</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>message</td>
            <td>消息文本</td>
            <td>String</td>
            <td>--</td>
            <td>--</td>
          </tr>
          <tr>
            <td>closeable</td>
            <td>是否显示关闭按钮，默认不显示</td>
            <td>Boolean</td>
            <td>--</td>
            <td>false</td>
          </tr>
          <tr>
            <td>duration</td>
            <td>设置自动关闭的时间间隔</td>
            <td>Number</td>
            <td>--</td>
            <td>2000</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>
<script>
export default {
  data () {
    return {
      text1: `<y-button type="primary" @click="handleInfoClick">提示</y-button>
<y-button type="warning" @click="handleWarningClick">警告</y-button>
<y-button type="success" @click="handleSuccessClick">成功</y-button>
<y-button type="error" @click="handleErrorClick">错误</y-button>
methods: {
    handleInfoClick () {
      this.$Message.info({ message: 'This is a mormal message', closeable: true })
    },
    handleWarningClick () {
      this.$Message.warning({ message: 'This is a warning message', closeable: true })
    },
    handleSuccessClick () {
      this.$Message.success({ message: 'This is a success message', closeable: true })
    },
    handleErrorClick  () {
      this.$Message.error({ message: 'This is a erro message', closeable: true })
    },
  },`,
      text2: `<y-button type="primary" @click="handleInfoClick2">提示</y-button>
methods: {
    handleInfoClick2 () {
      this.$Message.info({ message: 'This is a mormal message', duration: 3000 })
    },
  },`,
    }
  },
  methods: {
    handleInfoClick2 () {
      this.$Message.info({ message: 'This is a mormal message', duration: 3000 })
    },
    handleInfoClick () {
      this.$Message.info({ message: 'This is a mormal message', closeable: true })
    },
    handleWarningClick () {
      this.$Message.warning({ message: 'This is a warning message', closeable: true })
    },
    handleSuccessClick () {
      this.$Message.success({ message: 'This is a success message', closeable: true })
    },
    handleErrorClick  () {
      this.$Message.error({ message: 'This is a erro message', closeable: true })
    },
  },
}
</script>
